import React, { useEffect } from "react";  // Import useEffect
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Contact from "../components/Contact.jsx";
import { Link } from "react-router-dom";
import AOS from 'aos';
import { Helmet } from "react-helmet";
import SEO from "../components/SEO.jsx";

const ContactPage = () => {
  useEffect(() => {
    
      // Initialize AOS animations only on the client-side
      AOS.init({
        duration: 1200
      });
    
  }, []); // Add empty dependency array to run only once when the component mounts

  return (
    <>
     <SEO
      page="contact"
      customMeta={{
        title: "Contact Us - Shape Shifting Mastery",
        description: "Contact Us.",
      }}
    />  
      {/* <Helmet>
        <title>Contact Us - Shape Shifting Mastery</title>
        <meta name="description" content="Contact Us." />
        <meta name="keywords" content="shape, shape-shifting, contact" />
      </Helmet> */}
      
      <Contact />
      
     
    </>
  );
};

export default ContactPage;
